import { render, staticRenderFns } from "./PCFooterInfo.vue?vue&type=template&id=474b0002&scoped=true"
import script from "./PCFooterInfo.vue?vue&type=script&lang=js"
export * from "./PCFooterInfo.vue?vue&type=script&lang=js"
import style0 from "./PCFooterInfo.vue?vue&type=style&index=0&id=474b0002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b0002",
  null
  
)

export default component.exports